import { useAppDispatch, useAppSelector, endCall } from '@/store'
import ZoomEncounterCall from './ZoomEncounterCall'

/**
 * GlobalZoomCall — renders the telehealth call ONCE, at the app root.
 *
 * Mounted in App.tsx as a sibling of RouterProvider (i.e. OUTSIDE the router),
 * so route changes never unmount it. That's what makes a minimized (PIP) call
 * persist across the whole app: the call's iframe is created once and is not
 * torn down when the user navigates between pages.
 *
 * Pages open a call by dispatching startCall(roomId); they must NOT render
 * ZoomEncounterCall themselves (doing so re-creates the iframe per page and
 * loses the session on navigation). The call ends only when the End Call
 * button fires onClose → endCall().
 */
export const GlobalZoomCall = () => {
  const activeRoom = useAppSelector((s) => s.call.activeRoom)
  const dispatch = useAppDispatch()

  if (!activeRoom) return null

  return (
    <ZoomEncounterCall
      // Remount when the room changes so a new call starts clean; keep the
      // same instance (and the live iframe) for the lifetime of one room.
      key={activeRoom}
      roomId={activeRoom}
      onClose={() => dispatch(endCall())}
    />
  )
}
